import * as React from 'react';
import { useSelector } from 'react-redux';
import ContentForm from './ContentForm';
import { contentToEvent, eventToContent } from '../utils/eventMapper';

// Adapter that lets the Kendo Scheduler use the app's existing ContentForm as its editor.
export const CalendarEventForm = (props) => {
  const { dataItem, onSubmit, onCancel, onClose } = props;
  const { groups } = useSelector(state => state.groupsReducer);

  const close = (event) => {
    if (onCancel) onCancel(event);
    if (onClose) onClose(event);
  };

  return (
    <ContentForm
      groups={groups}
      values={eventToContent(dataItem)}
      isEdit={!!dataItem.id}
      initialType={dataItem.objectType || 'Event'}
      cancelEdit={close}
      onSubmit={(formValues) => onSubmit({ value: contentToEvent(formValues) })}
    />
  );
};

export default CalendarEventForm;
